var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "soli-round",
      class: {
        "v-card v-sheet pa-3 white v-card--flat": _vm.errorState && _vm.dark,
        "px-4": _vm.$vuetify.breakpoint.xs && !_vm.contained,
      },
    },
    [
      _c(
        "p",
        {
          staticClass: "caption red--text mx-auto",
          class: { "my-8": !_vm.errorState },
        },
        [_vm._v("\n        " + _vm._s(Object.values(_vm.errors)[0]) + "\n    ")]
      ),
      _vm._v(" "),
      _c("SoliBtn", {
        staticClass: "font-weight-bold",
        attrs: {
          type: "submit",
          text: _vm.text,
          loading: _vm.loading,
          gradient: _vm.valid
            ? _vm.dark
              ? `${_vm.gradient}-default-shadow`
              : _vm.gradient
            : null,
          block: "",
          plain: !_vm.valid,
          icon: _vm.icon,
          large: _vm.large,
          flat: _vm.errorState || !_vm.valid,
          disabled: _vm.disabled,
          color: "soli-status-grey",
        },
        on: {
          click: function ($event) {
            return _vm.submit()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }